'use strict';

var FaresPanelController = function FaresPanelController($scope, $q, dataRetrieverService, dataRetrieverConstantsService, faresPanelService, dataService, FaresConstants) {
  $scope.screen = dataRetrieverConstantsService.FARES_SCREEN;
  $scope.initState = function () {
    return {
      brushFilters: {},
      isFBCodeGridVisible: false,
      isFBGroupGridVisible: false,
      averageFaresGridState: {
        showAverageFaresGrid: true,
        selectedFlowType: 'REGULAR'
      },
      isFBCUsageChartVisible: false,
      isFBCApplicabilityChartVisible: false
    };
  };
  $scope.resetStateOnSearch = function () {
    $scope.screenState.brushFilters = {};
    $scope.screenState.isFBCodeGridVisible = false;
    $scope.screenState.isFBGroupGridVisible = false;
    onSearchChangeEvent();
  };
  $scope.screenState = $scope.initState();
  function setCustomChartSearch() {
    var chartSearchRules = faresPanelService.getFaresChartSearchCriteria();
    dataRetrieverService.getDataRetriever($scope.screen, dataRetrieverConstantsService.FARES_CHART_MODE).setCustomSearchCriteriaRules($q.when(chartSearchRules));
  }
  function onSearchChangeEvent() {
    dataRetrieverService.setBrushFilters($scope.brushFilters, $scope.screen);
    dataService.clearCache();
    setCustomChartSearch();
  }
  $scope.mode = null;
  $scope.$on('search-criteria:searchChangeEvent', $scope.resetStateOnSearch);
  $scope.$on('fares:modeChanged', function (event, mode) {
    $scope.mode = mode;
  });
  $scope.isFareAnalysisModeEnabled = function () {
    return $scope.mode === FaresConstants.SCREEN_VALUE.FARE_ANALYSIS;
  };
  $scope.isAdjustmentModeEnabled = function () {
    return $scope.mode === FaresConstants.SCREEN_VALUE.ADJUSTMENTS;
  };
  $scope.isSurchargeUpload = function () {
    return $scope.mode === FaresConstants.SCREEN_VALUE.SURCHARGE_UPLOAD;
  };
};
FaresPanelController.$inject = ['$scope', '$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'FaresPanelService', 'DataService', 'FaresConstants'];
module.exports = FaresPanelController;